<template>
  <div class="projects-page">
    <section class="section-project-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container d-flex">
        <div class="serach-box">
          <base-input
            alternative
            :placeholder="$t('Search_Projects')"
            v-model="search"
            addon-right-icon="fa fa-search"
          ></base-input>
        </div>
      </div>
    </section>
    <section class="section pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <h3 class="black-h3" v-if="!this.$route.query.p">
              <span
                class="icon icon-shape bg-gradient-white icon-lg shadow mr-2 rounded-circle text-success"
              >
                <i class="ni ni-building"></i>
              </span>
              {{$t('All_Projects')}}
            </h3>

            <h3 class="black-h3" v-if="this.$route.query.p == 'COMPLETED'">
              <span
                class="icon icon-shape bg-gradient-white icon-lg shadow mr-2 rounded-circle text-success"
              >
                <i class="ni ni-building"></i>
              </span>
              {{$t('Completed_Projects')}}
            </h3>

            <h3 class="black-h3" v-if="this.$route.query.p == 'IN-QUEUE'">
              <span
                class="icon icon-shape bg-gradient-white icon-lg shadow mr-2 rounded-circle text-success"
              >
                <i class="ni ni-building"></i>
              </span>
              {{$t('In_queue_Projects')}}
            </h3>

            <h3 class="black-h3" v-if="this.$route.query.p == 'RUNNING'">
              <span
                class="icon icon-shape bg-gradient-white icon-lg shadow mr-2 rounded-circle text-success"
              >
                <i class="ni ni-building"></i>
              </span>
              {{$t('Running_Projects')}}
            </h3>

            <div class="row row-grid">
              <div class="col-lg-4" v-for="(project,index) in items" :key="index">
                <ProjectCard
                  v-bind:cardData="project"
                  @updateSelectedCardData="updateSelectedCardData"
                />
              </div>
              <BankDetails :viewAllCardData="selectedCard" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ProjectCard from "./components/ProjectCard";
import BankDetails from "./components/BankDetails";
import axios from "axios";
import qs from "qs";
var clearTimeoutData;
export default {
  data() {
    return {
      items: [],
      search: "",
      selectedCard: null
    };
  },
  watch: {
    search(val) {
      var me = this;
      if (clearTimeoutData) clearTimeout(clearTimeoutData);

      clearTimeoutData = setTimeout(() => {
        me.getViewAllProjects();
      }, 500);
    }
  },
  name: "projects",
  components: {
    ProjectCard,
    BankDetails
  },
  methods: {
    getRequest() {
      var _filter = [];
      if (this.search) {
        _filter.push({
          type: "or",
          items: [
            {
              field: "name",
              value: "%" + this.search + "%",
              op: "ilike"
            },
            {
              field: "description",
              value: "%" + this.search + "%",
              op: "ilike"
            }
            //   {
            //     field : 'payee_email' ,
            //     value : '%' + this.search + '%',
            //     op : 'ilike'
            //   },
          ]
        });
      }

      //   if(this.amount !=null && this.amount != undefined) {
      //         _filter.push({
      //       field : 'amount' ,
      //       value : this.amount,
      //       op : this.amount_type2
      //     },);
      //   }

      //      if(this.status !=null && this.status != undefined) {
      //         _filter.push({
      //       field : 'status' ,
      //       value : this.status,
      //       op : this.status
      //     },);
      //   }

      if (this.$route.query.p != null && this.$route.query.p != undefined) {
        _filter.push({
          field: "category",
          value: this.$route.query.p,
          op: "eq"
        });
      }

      var _response = {
        filters: _filter
        // pagination : {
        //   page : this.pagination.page,
        //   page_size : this.pagination.rowsPerPage
        // //  page:1,
        //   // page_size:25
        // },
        // sorts : {}
      };
      //   if(this.pagination && this.pagination.sortBy){
      //       _response.sorts[this.pagination.sortBy] = this.pagination.descending ? 'desc' : 'asc';
      //   }
      return _response;
    },

    getViewAllProjects() {
      var _request = this.getRequest();
      var queryString = qs.stringify(_request);
      var urlWithService = process.env.VUE_APP_API_URL + `/campaigns/default/?`;
      urlWithService = urlWithService + queryString;

      const token = localStorage.getItem("token");

      axios({
        method: "get",
        url: urlWithService,
        headers: { Authorization: ` ${token}` }
      })
        .then(Response => {
          if (Response) {
            this.items = Response.data.list || [];
            this.total_items = Response.data.pagination || {};
            console.log("routes params fund", this.$route);
          }
        })
        .catch(error =>
          console.log("erreror in project funds function", error)
        );
    },
    updateSelectedCardData(_data) {
      this.selectedCard = _data;
      console.log("selected card data", this.selectedCard);
    }
  },

  mounted() {
    console.log("routes are", this.$route.query.q);
    console.log("selected card data", this.selectedCard);
    this.getViewAllProjects();
  }
};
</script>
<style>
</style>
